/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "6ca44f3825a752245cdeb927ee4c6cd3889d6d39";
